/**
 * @generated SignedSource<<bf94c66fe487dd52eeb936f5ee667c86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SlackProductConnectionSlackChannelType = "private" | "public" | "%future added value";
export type SlackChannelSelectQuery$variables = {
  id: string;
};
export type SlackChannelSelectQuery$data = {
  readonly organization: {
    readonly slack?: {
      readonly availableChannels: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly type: SlackProductConnectionSlackChannelType;
      }> | null;
    } | null;
    readonly viewerMembership?: {
      readonly organizationMembershipSlackConnection: {
        readonly id: string;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ConnectSlackTooltipFragment">;
  } | null;
};
export type SlackChannelSelectQuery = {
  response: SlackChannelSelectQuery$data;
  variables: SlackChannelSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "SlackChannel",
  "kind": "LinkedField",
  "name": "availableChannels",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "OrganizationMembershipSlackConnection",
  "kind": "LinkedField",
  "name": "organizationMembershipSlackConnection",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SlackChannelSelectQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SlackConnection",
                "kind": "LinkedField",
                "name": "slack",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationMembership",
                "kind": "LinkedField",
                "name": "viewerMembership",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ConnectSlackTooltipFragment"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SlackChannelSelectQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SlackConnection",
                "kind": "LinkedField",
                "name": "slack",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationMembership",
                "kind": "LinkedField",
                "name": "viewerMembership",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c776d0b32504cab3a78e7ccebef0846c",
    "id": null,
    "metadata": {},
    "name": "SlackChannelSelectQuery",
    "operationKind": "query",
    "text": "query SlackChannelSelectQuery(\n  $id: ID!\n) {\n  organization: node(id: $id) {\n    __typename\n    ... on Organization {\n      slack {\n        availableChannels {\n          id\n          name\n          type\n        }\n        id\n      }\n      viewerMembership {\n        organizationMembershipSlackConnection {\n          id\n        }\n        id\n      }\n      ...ConnectSlackTooltipFragment\n    }\n    id\n  }\n}\n\nfragment ConnectSlackTooltipFragment on Organization {\n  viewerMembership {\n    organizationMembershipSlackConnection {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1da98aa04d7e425269001eb651eb032a";

export default node;
